<!-- 图文信息分页展示列表：模块头+图片+标题+分页 -->
<template>
  <div class="content-block">
    <div class="info-list-content">

      <ul class="list-tab-ul-1" v-if="tabList.length>0">
        <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.type==params.type ?'li-active' : '']"
            v-on:click="selectedAct(tab.type)">{{ tab.title }}
        </li>
      </ul>
      <div class="spec-ul" v-if="listSpecs.length>0">
        <span>规格：</span>
        <a :class="[params.specId==0?'active':'']" @click="changeSpec(0)">全部</a>
        <a v-for="item in listSpecs" :class="[params.specId==item.id?'active':'']" :key="'spec_'+item.id"
           @click="changeSpec(item.id)">{{ item.name }}</a>
      </div>
      <!--    <div class="spec-ul" v-if="params.type==1&&listDependency.length>0">-->
      <!--      <span>所属：</span>-->
      <!--      <a :class="[params.dependency==''?'active':'']" @click="changeDependency('')">全部</a>-->
      <!--      <a v-for="(item,index) in listDependency" :class="[params.dependency==item.dependency?'active':'']" :key="'den_'+index" @click="changeDependency(item.dependency)">{{item.dependency}}</a>-->
      <!--    </div>-->
      <div class="spec-ul" v-if="params.type==2&&listMarket.length>0">
        <span>市场：</span>
        <a :class="[params.marketId==''?'active':'']" @click="changeMarket(0)">全部</a>
        <a v-for="(item,index) in listMarket" :class="[params.marketId==item.id?'active':'']" :key="'den_'+index"
           @click="changeMarket(item.id)">{{ item.name }}</a>
      </div>
      <div v-if="chinaSale" style="height: 50px;font-size: 18px;color:#FF5C00;">{{chinaSale.message}}</div>
      <AvocadoPriceDataList :loading="loading" :type="params.type" :page-info="pageInfo" @pageChange="queryPage"
                            @itemClick="handlePriceClick"></AvocadoPriceDataList>
    </div>
  </div>
</template>

<script>
import Pagination from '../utils/Pagination'
import AvocadoPriceDataList from './AvocadoPriceDataList'

export default {
  name: 'InfoPageList05',
  components: {
    'pagination': Pagination,
    'AvocadoPriceDataList': AvocadoPriceDataList
  },
  props: {
    tabClass: {
      type: String,
      default: 'list-tab-ul'
    }
  },
  data() {
    return {
      tabList: [{title: '产地价格', type: '1'}, {title: '市场价格', type: '2'}],
      chinaSale: null,
      listSpecs: [],
      listDependency: [],
      listMarket: [],
      params: {
        type: 1,
        specId: 0,
        dependency: '',
        marketId: 0
      },
      pageInfo: {
        list: [],
        page: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      },
      loading: false
    }
  },
  created: function () {
    if (this.$route.query.type) {
      this.params.type = this.$route.query.type
    }

    this.fetchMarket()
    this.fetchDependency()
    this.fetchSpecs()
    this.fetchData()
  },
  methods: {
    selectedAct: function (type) {
      this.params.type = type
      this.params.dependency = ''
      this.params.marketId = 0
      this.params.page = 1
      this.fetchData()
    },
    queryPage(e) {
      this.pageInfo.page.page = e.page
      this.pageInfo.page.pageSize = e.pageSize

      this.fetchData()
    },
    changeSpec(id) {
      this.params.specId = id
      this.pageInfo.page.page = 1
      this.fetchData()
    },
    changeDependency(den) {
      this.params.dependency = den
      this.pageInfo.page.page = 1
      this.fetchData()
    },
    changeMarket(id) {
      this.params.marketId = id
      this.pageInfo.page.page = 1
      this.fetchData()
    },
    fetchMarket() {
      this.$dataApi.getMarketList({}).then((res) => {
        if (res.code !== 1) {
          return
        }
        const {data} = res
        this.listMarket = data
      })
    },
    fetchDependency() {
      this.$dataApi.getAvocadoDependencyList({}).then((res) => {
        if (res.code !== 1) {
          return
        }
        const {data} = res
        this.listDependency = data
      })
    },
    fetchSpecs() {
      this.$dataApi.getAvocadoSpecList({}).then((res) => {
        if (res.code !== 1) {
          return
        }
        const {data} = res
        this.listSpecs = data
      })
    },
    fetchData: function () {
      this.loading = true
      this.$dataApi.getAvocadoPriceDataList({
        ...this.params,
        ...this.pageInfo.page
      }).then(res => {
        if (res.code !== 1) {
          return
        }
        const {data} = res
        this.pageInfo.list = data.list
        this.pageInfo.page.page = data.page
        this.pageInfo.page.total = data.total
        this.loading = false
      })
      this.fetchConfig()
    },
    fetchConfig: function () {
      if(Number(this.params.type) !== 1) {
        this.chinaSale = null
        return
      }
      this.$dataApi.getAvocadoConfig({}).then((res) => {
        if (res.code !== 1) {
          this.chinaSale = null
          return
        }
        const sale = (res.data.find(x => x.key === 'sale') || {value: '1'}).value || '1'
        const message = (res.data.find(x => x.key === 'over_message') || {value: ''}).value || ''

        this.chinaSale = {
          sale,
          message
        }
      })
    },
    handlePriceClick(item) {
      this.$router.push({name: 'avocadoPriceDetail', params: {id: item.id}})
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mask-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, .8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mask-loading .loading {
  width: 30px;
  height: 30px;
  animation: loadingRotate 2s infinite linear;
  opacity: .6;
}

@keyframes loadingRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.avocado-price-table {
  width: 100%;
  box-sizing: border-box;
  border-spacing: 0;
  border-collapse: collapse;
  position: relative;
}

.avocado-price-table thead {
  height: 50px;
  background: #F5F5F5;
  border-bottom: 2px solid rgb(89, 129, 24);
}

.avocado-price-table thead th {
  height: 50px;
}

.avocado-price-table tbody tr {
  height: 50px;
  color: rgb(89, 129, 24);
}

.avocado-price-table tbody tr td {
  cursor: pointer;
  font-weight: 700;
}

.avocado-price-table tbody tr:hover {
  background: #f5f5f5 !important;
}

.avocado-price-table tbody tr:nth-child(odd) {

}

.avocado-price-table tbody tr:nth-child(even) {
  background: rgba(89, 129, 24, .1);
}

.avocado-price-table .t1 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t2 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t3 {
  flex: 1;
}

.avocado-price-table .t4 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t5 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t6 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t7 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t8 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .t9 {
  width: 10%;
  text-align: center;
}

.avocado-price-table .chart-icon {
  width: 20px;
  height: 20px;
}

.spec-ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding: 10px 20px;
  font-size: 18px;
}

.spec-ul span {
  font-weight: 700;
  color: rgb(89, 129, 24);
}

.spec-ul a {
  color: #333333;
  margin: 0 10px;
  cursor: pointer;
}

.spec-ul a.active, .spec-ul a:hover {
  color: rgb(89, 129, 24);
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: block;
  position: relative;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  height: 100%;
  text-align: left;
//background:red;
}

.title-search-div {
  position: relative;
  float: right;
  height: 30px;
  width: 260px;
  background: green;
  bottom: -9px;
}

.title-search-div .title-search-input {
  display: block;
  float: left;
  width: 220px;
  height: 30px;
  outline-style: none;
  border: 1px solid #dbdbdb;
  border-bottom: 0px solid #dbdbdb;
  font-size: 12px;
  padding-left: 5px;
  background: #dbdbdb;
}

.title-search-div .title-search-button {
  display: block;
  float: left;
  width: 40px;
  height: 30px;
  text-decoration: none;
  background: #515151;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  letter-spacing: 5px;
  background-image: url(./../../assets/search_1.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: center center;
}

.title-search-button:hover {
  cursor: pointer;
//background-color: #000;
}

.list-tab-ul {
  display: flex;
  justify-content: flex-start;
  margin: 10px auto;
  width: 100%;
  height: 40px;
  text-align: center;
  list-style-type: none;
  padding: 5px;
  background: #eee;
}

.list-order-ul {
  display: flex;
  justify-content: flex-start;
  margin: 10px auto;
  width: 100%;
  height: 40px;
  text-align: center;
  list-style-type: none;
  padding: 5px;
  background: #eee;
}

.list-tab-ul-1 {
  display: flex;
  justify-content: flex-start;
  margin: 10px auto;
  width: 100%;
  height: 50px;
  text-align: center;
  list-style-type: none;
  padding: 5px 5px 15px 0px;
  border-bottom: 1px solid #bbb;
}

.list-tab-ul-1 .list-tab-li {
  float: left;
  margin: 0px 20px 0px 0px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118- #BE550F;
}

.list-tab-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118- #BE550F;
}

.list-order-li-label {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 40px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  background: #598118- #BE550F;
}

.list-order-li {
  float: left;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 50px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118- #BE550F;
}

.list-order-li-total {
  float: right;
  right: 0px;
  margin: 0px 5px 0px 315px;
  height: 30px;
  width: 150px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
}

.list-tab-li:hover {
  cursor: pointer;
  background: #bbb;
  color: #000;
}

.list-order-li:hover {
  cursor: pointer;
  background: #bbb;
  color: #000;
}

.li-active {
  color: #ffffff !important;
  background: #598118;
  background: -moz-linear-gradient(left, #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #BE550F), color-stop(100%, #BE550F));
  background: -webkit-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: -o-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: -ms-linear-gradient(left, #598118 f0%, #BE550F 100%);
  background: linear-gradient(to right, #598118 f0%, #BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#598118', endColorstr='#BE550F', GradientType=0);
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoPageList05.vue